import { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Accordion FAQ block — the other half of what a "text only" page like
 * FAQ needs (paired with GenericRichText for any intro copy). Reusable
 * across any admin-created custom page. */
export default function GenericFaqList({ fields = {} }) {
  const { eyebrow, headline, items = [] } = fields;
  const [openIndex, setOpenIndex] = useState(null);

  if (items.length === 0) return null;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {(eyebrow || headline) && (
          <div className="text-center mb-10">
            {eyebrow && (
              <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-3">
                {eyebrow}
              </p>
            )}
            {headline && (
              <h2 className="text-white font-bold text-3xl sm:text-4xl">
                {headline}
              </h2>
            )}
          </div>
        )}
        <div className="space-y-3">
          {items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className="rounded-2xl border border-white/10 bg-white/5 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-white font-semibold text-sm sm:text-base">
                    {item.question}
                  </span>
                  <ChevronDown
                    className={`h-4 w-4 text-white/50 shrink-0 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <p className="px-5 pb-4 text-white/60 text-sm leading-relaxed whitespace-pre-line">
                    {item.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
